import { render, staticRenderFns } from "./JustificativaDoPagamentoCartao.vue?vue&type=template&id=9a4dbb20&scoped=true"
import script from "./JustificativaDoPagamentoCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./JustificativaDoPagamentoCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4dbb20",
  null
  
)

export default component.exports